import { Content, Exercise, Instruction } from '@ilteducation/exercise-service-types';

const parseReflection = (tableRows: any[]): Partial<Exercise>[] => {
  const content: Content[] = [];

  tableRows.forEach((tr) => {
    const question = tr.querySelectorAll('td')[0]?.innerText?.trim();
    if (question) {
      content.push({
        type: 'reflection-task',
        title: question,
        description: question,
      } as Instruction);
    }
  });

  if (!content.length) {
    return [];
  }

  return [
    {
      type: 'reflection',
      title: 'Reflection',
      content,
    },
  ];
};

export default parseReflection;
